import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'

export interface DriversFilterValues extends FilterValues {
  keywords: string[]
}

const defaultFilters: DriversFilterValues = {
  keywords: [],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as DriversViewProvider, useListView as useDriversView }
